export default "__VITE_ASSET__DttTKgbQ__"